import React, { createContext, useContext, useState, ReactNode } from 'react'
import { Payment } from '../types/order'

interface PaymentReopenContextType {
  paymentToReopen: Payment | null
  setPaymentToReopen: (payment: Payment | null) => void
}

const PaymentReopenContext = createContext<PaymentReopenContextType | undefined>(undefined)

export const PaymentReopenProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [paymentToReopen, setPaymentToReopen] = useState<Payment | null>(null)

  return (
    <PaymentReopenContext.Provider
      value={{
        paymentToReopen,
        setPaymentToReopen
      }}
    >
      {children}
    </PaymentReopenContext.Provider>
  )
}

export const usePaymentReopen = (): PaymentReopenContextType => {
  const context = useContext(PaymentReopenContext)
  if (context === undefined) {
    throw new Error('usePaymentReopen must be used within a PaymentReopenProvider')
  }
  return context
}

